import './App.css';
import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import HomeScreen from './Screens/HomeScreen';
import AboutPage from './Screens/AboutNCGSA';
import SpatialDecisionSupportLab from './Components/ResearchLabs/SDSSL';
import SpaceandAstrophysicsLab from './Components/ResearchLabs/SARL';
import SpaceEducationandResearchLab from './Components/ResearchLabs/GSERL';
import SmallSatelliteTechnologyandResearchLab from './Components/ResearchLabs/SSTRL';
import AgriculturalRemoteSensingLab from './Components/ResearchLabs/ARSL';
import ICase from './Components/LinkagesComponent/ICase';
import LinkagesandOutreach from './Screens/Linkages&Outreach';
import Opportunities from './Screens/Oppurtunities';
import InternshipProgram from './Screens/InternshipScreen';
import Contact from './Screens/ContactScreen';
import ResearchLabsScreen from './Screens/ResearchLabsScreen';
import AppHeader from './Layout/Header';
import FooterComponent from './Layout/Footer';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import GSAGL from './Components/ResearchLabs/GSAGL';
import RemoteSensingGISClimaticResearchLab from './Components/ResearchLabs/RSGCRL';
import EventsOutreach from './Components/LinkagesComponent/SpaceAwareness&Outreach/EventsOutreach';
import SpaceSummerSchool from './Components/LinkagesComponent/SpaceAwareness&Outreach/SSS Components/SpaceSummerSchool';
import WorldSpaceWeek from './Components/LinkagesComponent/SpaceAwareness&Outreach/WSW Components/WorldSpaceWeek';
import StudentSatelliteOutreach from './Components/LinkagesComponent/SpaceAwareness&Outreach/SSO Components/StudentSatelliteOutreach';
import AstronomyOutreach from './Components/LinkagesComponent/SpaceAwareness&Outreach/AO Components/AstronomyOutreach';
import SpaceDestinationSchools from './Components/LinkagesComponent/SpaceAwareness&Outreach/SDS Components/SpaceDestinationSchools';
import SpaceOutreachFilm from './Components/LinkagesComponent/SpaceAwareness&Outreach/SOF Components/SpaceOutreachFilm';
import InternationalConferences from './Components/LinkagesComponent/International Conferences/InternationalConferences';
import ICASTPage from './Components/LinkagesComponent/International Conferences/ICAST Components/ICASTPage';
import CapacityBuildingPage from './Components/LinkagesComponent/CapacityBuilding/CapacityBuildingPage';
import CollaborationsPage from './Components/LinkagesComponent/Collaborations/CollaborationsPage';
import ResearchFundPage from './Components/ResearchFund/ResearchFundPage';

const NotFound = () => (
  <>
    <AppHeader />
    <Result
      status="404"
      title="Page not found"
      subTitle="The page you requested does not exist or has moved."
      extra={<Link to="/"><Button type="primary">Return home</Button></Link>}
    />
    <FooterComponent />
  </>
);


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Route for Home Page */}
          <Route path="/" element={<HomeScreen />} />
          <Route path="/about" element={<AboutPage />}/>
          <Route path="/linkages" element={<LinkagesandOutreach />}/>
  
          <Route path="/opportunities" element={<Opportunities />}/>
          <Route path="/internships" element={<InternshipProgram />}/>
          <Route path="/contact" element={<Contact />}/>
          <Route path="/research-labs" element={<ResearchLabsScreen />}/>


          <Route path="/sdssl" element={<SpatialDecisionSupportLab />}/>
          <Route path="/sarl" element={<SpaceandAstrophysicsLab />}/>
          <Route path="/gserl" element={<SpaceEducationandResearchLab />}/>
          <Route path="/sstrl" element={<SmallSatelliteTechnologyandResearchLab />}/>
          <Route path="/arsl" element={<AgriculturalRemoteSensingLab />}/>
          <Route path="/gsagl" element={<GSAGL />}/>
          <Route path="/rsgcrl" element={<RemoteSensingGISClimaticResearchLab />}/>
          <Route path="/icase" element={<ICase />}/>
          <Route path="/events" element={<EventsOutreach />}/>
          <Route path="/space-summer-school" element={<SpaceSummerSchool />}/>
          <Route path="/world-space-week" element={<WorldSpaceWeek />}/>
          <Route path="/space-week" element={<Navigate to="/world-space-week" replace />}/>
          <Route path="/student-satellite-outreach" element={<StudentSatelliteOutreach />}/>
          <Route path="/astronomy-outreach" element={<AstronomyOutreach />}/>
          <Route path="/space-destination-schools" element={<SpaceDestinationSchools />}/>
          <Route path="/space-outreach-film" element={<SpaceOutreachFilm />}/>
          <Route path="/international-conferences" element={<InternationalConferences />}/>
          <Route path="/icast-2025" element={<ICASTPage />}/>
          <Route path="/capacity-building-workshops-forums" element={<CapacityBuildingPage />}/>
          <Route path="/collaborations" element={<CollaborationsPage />}/>
          <Route path="/collaboration" element={<Navigate to="/collaborations" replace />}/>
          <Route path="/research-fund" element={<ResearchFundPage />}/>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

